// @flow
import type {
  Comment,
} from 'hfty-model-comments/types'

// Libs
import _find from 'lodash/find'

// Utils
import traverse from 'fc-utils/traverse'

// Libs
import { createSelector } from 'reselect'

// selectors
import { comments$ } from 'hfty-comments'

// Constants
import {
  PROP_ID,
} from 'hfty-model-comments'

// Local
const path$ = traverse(['router', 'location', 'pathname'])

export default createSelector(
  [path$, comments$],
  function (path: string, comments: Array<Comment>): ?string {
    const match = `${path || ''}`.match(/comments\/\d+\/recommendedRates\/(\d+)/)
    if (match && match.length > 1) {
      const commentId = Number(match[1])
      const comment = _find(comments, (comment: SoilJob): boolean => {
        return comment[PROP_ID] === commentId
      })
      return comment
    }

    return null
  }
)
